import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import { queryNotice } from "utils/api";

const App = () => {
  const [noticeList, setNoticeList] = useState([]);
  let history = useHistory();
  const goNoticeDetail = (noticeId) => {
    history.push(`/notice/${noticeId}`);
  };
  const goNoticeList = () => {
    history.push("/notice");
  };
  useEffect(() => {
    queryNotice({
      pageIndex: 1,
      pageSize: 3,
    }).then((res) => {
      if (res.data.success) {
        setNoticeList(res.data.result.items);
      }
    });
  }, []);
  return (
    <div className={style.tipContainer}>
      <div className={style.tipContent}>
        <div className={`${style.tipUl}`}>
          {noticeList.length
            ? noticeList.slice(0, 3).map((item) => (
                <div
                  className={`${style.tipItem}`}
                  key={item.noticeId}
                  onClick={() => {
                    goNoticeDetail(item.noticeId);
                  }}
                >
                  <div className={`${style.time}`}>
                    <i className={`${style.icon}`}></i>
                    <span className={`${style.t}`}>
                      {`${item.updateTime.split(/\s+/)[0].split("-")[1]}.${
                        item.updateTime.split(/\s+/)[0].split("-")[2]
                      }`}
                    </span>
                  </div>
                  <span className={`${style.text}`} title={item.noticeTitle}>
                    {item.noticeTitle}
                  </span>
                  <i className={`${style.next}`}></i>
                </div>
              ))
            : ""}
        </div>
        <div
          className={`${style.tipMore}`}
          onClick={() => {
            goNoticeList();
          }}
          clstag="pageclick|keycount|VopOpenIndex_1602911919488|23"
        >
          <span>查看全部</span>
          <i></i>
        </div>
      </div>
    </div>
  );
};

export default App;
